import {Agent} from '../../entity/core/agent';
import UserAgent from './user-agent';
import OrganizationAgent from './organization-agent';
import CountyAgent from './county-agent';
import StateAgent from './state-agent';
import TitleSectionTemplateAgent from './title-section-template-agent';
import TitleAgent from './title-agent';
import SectionAgent from './section-agent';
import {DocumentAgent} from './document-agent';
import TitleTemplateAgent from './title-template-agent';
import SearchAgent from './search-agent';
import SubscriptionAgent from './subscription-agent';
import ScraperConfigAgent from './scraper-config-agent';
import CountyLinkAgent from './county-link-agent';
import {AuditLogsAgent} from './audit-logs-agent';
import ProjectAgent from './project-agent';
import TitleSummaryRequestAgent from './title-summary-request-agent';
import TitleSummaryTemplateAgent from './title-summary-template-agent';
import InvoiceRequestAgent from './invoice-request-agent';
import BrandingTemplateAgent from './branding-template-agent';
import LineListRequestAgent from './line-list-request-agent';
import LineListTemplateAgent from './line-list-template-agent';
import {MetadataAgent} from './metadata-agent';
import MarketplaceAgent from './marketplace-agent';
import BusinessRecordAgent from './business-record-agent';
import {GrantAIAgent} from './grant-ai-agent';

const agent: Agent = {
  userAgent: new UserAgent(),
  organizationAgent: new OrganizationAgent(),
  countyAgent: new CountyAgent(),
  stateAgent: new StateAgent(),
  titleSectionTemplateAgent: new TitleSectionTemplateAgent(),
  titleAgent: new TitleAgent(),
  sectionAgent: new SectionAgent(),
  documentAgent: new DocumentAgent(),
  titleTemplateAgent: new TitleTemplateAgent(),
  searchAgent: new SearchAgent(),
  subscriptionAgent: new SubscriptionAgent(),
  scraperConfigAgent: new ScraperConfigAgent(),
  countyLinkAgent: new CountyLinkAgent(),
  auditLogsAgent: new AuditLogsAgent(),
  projectAgent: new ProjectAgent(),
  titleSummaryRequestAgent: new TitleSummaryRequestAgent(),
  titleSummaryTemplateAgent: new TitleSummaryTemplateAgent(),
  invoiceTemplateAgent: new InvoiceRequestAgent(),
  brandingTemplateAgent: new BrandingTemplateAgent(),
  lineListRequestAgent: new LineListRequestAgent(),
  lineListTemplateAgent: new LineListTemplateAgent(),
  metadataAgent: new MetadataAgent(),
  marketplaceAgent: new MarketplaceAgent(),
  businessRecordAgent: new BusinessRecordAgent(),
  grantAIAgent: new GrantAIAgent()
}

export const useAgent = (): Agent => {
  return agent;
}
